import React from 'react';

const renderInline = (line, lineKey) => line.split(/(\*\*.*?\*\*)/g).map((part, partIndex) => {
  const key = `${lineKey}-${partIndex}-${part.slice(0, 12)}`;
  if (part.startsWith('**') && part.endsWith('**')) {
    return <strong key={key} className="text-[#15181C]">{part.slice(2, -2)}</strong>;
  }
  return <React.Fragment key={key}>{part}</React.Fragment>;
});

const LegalText = ({ content }) => (
  <div className="text-[16px] leading-[1.75] text-[#4E5359]">
    {content.split('\n').map((line, lineIndex) => {
      const lineKey = `${lineIndex}-${line.slice(0, 24) || 'blank'}`;
      return line ? <React.Fragment key={lineKey}>{renderInline(line, lineKey)}<br /></React.Fragment> : <br key={lineKey} />;
    })}
  </div>
);

export default LegalText;